export const iconFontAwesomeCodingCodePullRequest = (
	<i className="fa-solid fa-code-pull-request"></i>
);
